// extracted by mini-css-extract-plugin
module.exports = {"container":"WeDidItHeader_container__Ph541","icon":"WeDidItHeader_icon__cCbTf"};